import styled from "styled-components";
import { TextButton } from "./Button";

export const Snack = styled.div`
  transition-property: opacity, bottom, left, right, width, margin,
    border-radius;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  border-radius: 4px;
  font-size: 14px;
  min-height: 14px;
  background-color: ${props => props.theme.snackBar.background};
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${props => props.theme.text.primaryInverted};
  line-height: 22px;
  padding: 18px 24px;
  margin: 1rem;
  bottom: 0;
  left: 5rem;
  opacity: 0;
  will-change: transition;
  z-index: 999;

  &.visible {
    opacity: 100;
    bottom: 5rem;
  }
`;

export const SnackButton = styled(TextButton)`
  font-size: inherit;
  margin-left: 0.25rem;
  color: ${props => props.theme.colors.secondary};

  &:active {
    background-color: ${props => props.theme.snackBar.buttonActive} !important;
  }
  &:hover {
    background-color: ${props => props.theme.snackBar.buttonHover} !important;
  }
`;

export const SnackButton2 = styled(TextButton)`
  background: inherit;
  display: inline-block;
  border: none;
  font-size: inherit;
  color: #ffeb3b;
  margin: 0px 0px 0px 24px;
  padding: 0px;
  min-width: min-content;
`;



// WEBPACK FOOTER //
// ./app/styled-components/SnackBar.js